// extracted by mini-css-extract-plugin
module.exports = {"story-author":"author_story-author__2hJZr"};